import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  cardText: {
    textTransform: 'uppercase',
  },
  boxItems: {
    gap: theme.spacing(2),
  },
  tab: {
    color: '#CCCCCC',
    backgroundColor: theme.palette.white,
    cursor: 'pointer',
    width: '100%',
    height: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',

    '&:hover': {
      backgroundColor: '#EEE',
    },
  },
  tabActive: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.white,
    },
  },
}))

export default styles
